"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MANAGE_QUESTION_COMMENT = exports.RESET_QUESTION = exports.UPDATE_QUESTION = void 0;
const client_1 = require("@apollo/client");
exports.UPDATE_QUESTION = (0, client_1.gql) `
  mutation updateQuestion($input: UpdateQuestionInput!) {
    admin {
      updateQuestion(input: $input) {
        id
      }
    }
  }
`;
exports.RESET_QUESTION = (0, client_1.gql) `
  mutation ResetQuestion($ids: [ID!]!, $operation: String!) {
    admin {
      resetQuestion(ids: $ids, operation: $operation)
    }
  }
`;
exports.MANAGE_QUESTION_COMMENT = (0, client_1.gql) `
  mutation ManageQuestionComment($id: ID!, $operation: String!) {
    admin {
      manageQuestionComment(id: $id, operation: $operation)
    }
  }
`;
